import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Category from '../../entities/category';
import Task from '../../entities/task';
import TemplateTask from '../../entities/templateTask';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteCategory(): boolean {
return true;
}
export function collectCategoryDeleteImpact(category: Category, context: DeleteImpactContext): void {
const key = 'category:' + category.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const taskCategoriesImpact = workingRows<Task>('task', findAll<Task>('tasks')).filter(taskRef => taskRef.categories?.includes(category.id));
taskCategoriesImpact.forEach(taskRef => addDeleteImpact(context, 'task:' + taskRef.id, 'tasks'));
const templateTaskCategoriesImpact = workingRows<TemplateTask>('templateTask', findAll<TemplateTask>('templateTasks')).filter(templateTaskRef => templateTaskRef.categories?.includes(category.id));
templateTaskCategoriesImpact.forEach(templateTaskRef => addDeleteImpact(context, 'templateTask:' + templateTaskRef.id, 'templateTasks'));}
export function deleteImpactCategory(category: Category): DeleteImpact {
const context = deleteImpactContext();
collectCategoryDeleteImpact(category, context);
return deleteImpactCounts(context);
}
export function deleteCategory(category: Category, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteCategory()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectCategoryDeleteImpact(category, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || category.id};
}
const key = 'category:' + category.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('categories', category.id)]).filter(taskTemp => taskTemp.categories?.includes(category.id)).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.categories = _task.categories?.filter(id => id !== category.id) || [];

_work.set('task:' + _task.id, _task);
dispatch(Actions.TaskActions.saveTaskQueue(_task), 'task:' + _task.id);
});
workingRows<TemplateTask>('templateTask', [...store.getState().templateTasks.getMappingFor('categories', category.id)]).filter(templateTaskTemp => templateTaskTemp.categories?.includes(category.id)).forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
if (_templateTask.status === 'D') return;
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.categories = _templateTask.categories?.filter(id => id !== category.id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask), 'templateTask:' + _templateTask.id);
});
const deleted = category.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.CategoryActions.removeCategoryQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceCategory(category: Category, replaceWith: Category, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = category.id;}
const _work = workingSet();
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('categories', category.id)]).filter(taskTemp => taskTemp.categories?.includes(category.id)).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.categories = _task.categories?.map(id => (id === category.id) ? replaceWith.id : id) || [];

_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
workingRows<TemplateTask>('templateTask', [...store.getState().templateTasks.getMappingFor('categories', category.id)]).filter(templateTaskTemp => templateTaskTemp.categories?.includes(category.id)).forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
if (_templateTask.status === 'D') return;
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.categories = _templateTask.categories?.map(id => (id === category.id) ? replaceWith.id : id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});



return category;
}
